import { useState, useEffect, useRef } from "react";
import api from "../setupMiddleware"; // your axios instance

const useApiLoader = (excludedPaths = ["/notifications/mark-all-read"]) => {
  const [loading, setLoading] = useState(false);
  const activeRequests = useRef(0);

  const decrement = () => {
    activeRequests.current = Math.max(activeRequests.current - 1, 0);
    if (activeRequests.current === 0) {
      setLoading(false);
    }
  };

  const isExcluded = (url = "") => {
    return excludedPaths.some((path) => url.includes(path));
  };

  useEffect(() => {
    // Request interceptor → increment
    const reqInterceptor = api.interceptors.request.use(
      (config) => {
        if (!isExcluded(config.url)) {
          activeRequests.current += 1;
          setLoading(true);
        }
        return config;
      },
      (error) => {
        decrement();
        return Promise.reject(error);
      }
    );

    // Response interceptor → decrement
    const resInterceptor = api.interceptors.response.use(
      (res) => {
        if (!isExcluded(res.config.url)) {
          decrement();
        }
        return res;
      },
      (err) => {
        if (!isExcluded(err.config?.url)) {
          decrement();
        }
        return Promise.reject(err);
      }
    );

    // cleanup
    return () => {
      api.interceptors.request.eject(reqInterceptor);
      api.interceptors.response.eject(resInterceptor);
    };
  }, [excludedPaths]);

  return loading;
};

export default useApiLoader;
